import { ROUTES } from 'constants/routes';
import { MODULES, ACTIONS } from 'constants/permissions';

/**
 * Permission-driven navigation. Each item declares the (module, action) needed
 * to see it; the sidebar filters items the user's role can't access and hides
 * empty groups. Adding a menu entry is a data change here.
 *
 * Item shape:
 *   { id, label, icon, path, module, action, children? }
 * A `children` array makes the item a collapsible group (no own path).
 */
export const NAVIGATION = [
    {
    id: 'search',
    label: 'Search',
    icon: 'search',
    path: ROUTES.SEARCH,
    module: MODULES.SEARCH,
    action: ACTIONS.VIEW,
  },
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'grid',
    path: ROUTES.DASHBOARD,
    module: MODULES.DASHBOARD,
    action: ACTIONS.VIEW,
  },
  {
    id: 'stage1',
    label: 'Stage 1 · Feed',
    icon: 'inbox',
    path: ROUTES.STAGE1,
    module: MODULES.STAGE1,
    action: ACTIONS.VIEW,
  },
  {
    id: 'stage2',
    label: 'Stage 2 · Routing',
    icon: 'route',
    path: ROUTES.STAGE2,
    module: MODULES.STAGE2,
    action: ACTIONS.VIEW,
  },
  {
    id: 'briefing',
    label: 'Sahebji Briefing',
    icon: 'send',
    path: ROUTES.BRIEFING,
    module: MODULES.BRIEFING,
    action: ACTIONS.VIEW,
  },
  {
    id: 'storage1',
    label: 'Storage 1 · TRR',
    icon: 'package',
    path: ROUTES.STORAGE1,
    module: MODULES.STORAGE1,
    action: ACTIONS.VIEW,
  },
  {
    id: 'storage2',
    path: '/storage2',
    icon: 'archive',
    label: 'Storage 2 · Archive',
    module: MODULES.STORAGE2,
    action: ACTIONS.VIEW,
  },
  {
    id: 'ocr-storage',
    path: '/ocr-storage',
    icon: 'file',
    label: 'OCR Storage',
    module: MODULES.OCR_STORAGE,
    action: ACTIONS.VIEW,
  },
  {
    id: 'no-storage',
    label: 'No Storage',
    icon: 'trash',
    path: ROUTES.NO_STORAGE,
    module: MODULES.NO_STORAGE,
    action: ACTIONS.VIEW,
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'settings',
    module: MODULES.SETTINGS,
    action: ACTIONS.VIEW,
    children: [
      {
        id: 'settings-newspapers',
        label: 'Newspaper Master',
        icon: 'newspaper',
        path: ROUTES.SETTINGS_NEWSPAPERS,
        module: MODULES.NEWSPAPERS,
        action: ACTIONS.VIEW,
      },
      {
        id: 'settings-roles',
        label: 'Roles',
        icon: 'shield',
        path: ROUTES.SETTINGS_ROLES,
        module: MODULES.ROLES,
        action: ACTIONS.VIEW,
      },
      {
        id: 'settings-users',
        label: 'Users',
        icon: 'users',
        path: ROUTES.SETTINGS_USERS,
        module: MODULES.USERS,
        action: ACTIONS.VIEW,
      },
      {
        id: 'settings-activity-logs',
        label: 'Activity Logs',
        icon: 'activity',
        path: ROUTES.SETTINGS_ACTIVITY_LOGS,
        module: MODULES.ACTIVITY_LOGS,
        action: ACTIONS.VIEW,
      },
      {
        id: 'settings-system-config',
        label: 'System Configuration',
        icon: 'settings',
        path: ROUTES.SETTINGS_SYSTEM_CONFIG,
        module: MODULES.SYSTEM_CONFIG,
        action: ACTIONS.VIEW,
      },
    ],
  },
];

export default NAVIGATION;
